export { appLinkToReadableMap } from './app-link-to-readable.map';
